import { AppProblemModel } from '@/services/api/AppProblemModel'
import { resolveProblemMessage } from '@/services/api/resolveProblemMessage'
import { usePresentationTranslator } from '@/composables/usePresentationTranslator'
import { fieldIssuesMessage } from '@/composables/fieldIssuesMessage'

/**
 * Normalize $fetch/ofetch errors for inline forms and toasts.
 */
export function formatUserFacingFetchError(error: unknown, fallback: string): string {
  const problem = AppProblemModel.normalize(error)
  const t = usePresentationTranslator()
  const validationDetail = fieldIssuesMessage(problem, t)

  if (validationDetail !== null) return validationDetail

  return resolveProblemMessage(problem, t, fallback)
}
